import sfxBreadcrumbs from "./sfxBreadcrumbs"
import sfxButtons from "./sfxButtons"
import sfxCard from "./sfxCard"
import sfxContextMenu from "./sfxContextMenu"
import sfxDataPoint from "./sfxDataPoint"
import sfxEmpty from "./sfxEmpty"
import sfxErrorMsg from "./sfxErrorMsg"
import sfxHealthIndicator from "./sfxHealthIndicator"
import sfxImage from "./sfxImage"
import sfxInput from "./sfxInput"
import sfxIssues from "./sfxIssues"
import sfxNavigation from "./sfxNavigation"
import sfxOverlayNotifications from "./sfxOverlayNotifications"
import sfxProcedureSteps from "./sfxProcedureSteps"
import sfxProgressIndicator from "./sfxProgressIndicator"
import sfxQuaternarySelector from "./sfxQuaternarySelector"
import sfxScanners from "./sfxScanners"
import sfxSearch from "./sfxSearch"
import sfxSelect from "./sfxSelect"
import sfxSelectObject from "./sfxSelectObject"
import sfxSeparator from "./sfxSeparator"
import sfxSpinner from "./sfxSpinner"
import sfxTable from "./sfxTable"
import sfxTimeEdit from "./sfxTimeEdit"
import sfxToDo from "./sfxToDo"
import sfxTooltip from "./sfxTooltip"
import sfxUserDisplay from "./sfxUserDisplay"

export default {
  sfxBreadcrumbs,
  sfxButtons,
  sfxCard,
  sfxContextMenu,
  sfxDataPoint,
  sfxEmpty,
  sfxErrorMsg,
  sfxHealthIndicator,
  sfxImage,
  sfxInput,
  sfxIssues,
  sfxNavigation,
  sfxOverlayNotifications,
  sfxProcedureSteps,
  sfxProgressIndicator,
  sfxQuaternarySelector,
  sfxScanners,
  sfxSearch,
  sfxSelect,
  sfxSelectObject,
  sfxSeparator,
  sfxSpinner,
  sfxTable,
  sfxTimeEdit,
  sfxToDo,
  sfxTooltip,
  sfxUserDisplay,
}
